import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarLabel, MatSnackBarActions, MatSnackBarRef } from '@angular/material/snack-bar';
import { SvgIconComponent } from '@ngneat/svg-icon';

@Component({
  selector: 'app-pointee-snackbar',
  standalone: true,
  imports: [MatButtonModule, MatSnackBarLabel, MatSnackBarActions, SvgIconComponent],
  templateUrl: './pointee-snackbar.component.html',
  styleUrl: './pointee-snackbar.component.scss',
})
export class PointeeSnackbarComponent {
  snackBarRef = inject(MatSnackBarRef);
  configuration = inject(MatSnackBarRef).containerInstance.snackBarConfig;
}